import React, { useState } from 'react';
import API from '../services/api';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import '../App.css';

const Verify2FA = () => {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const email = localStorage.getItem('userEmail') || '';

  const handleVerify = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const resp = await API.post('/verify-2fa', { email, code });
      const token = resp.data?.access_token;
      if (!token) {
        throw new Error('Token not returned');
      }
      localStorage.setItem('token', token);
      toast.success('Welcome Back!');
      navigate('/dashboard');
    } catch (err) {
      const detail = err.response?.data?.detail || err.message;
      toast.error(detail || 'Verification failed');
    } finally {
      setLoading(false);
    }
  };

  const [resending, setResending] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);

  const handleResend = async () => {
    if (resendTimer > 0 || resending) return;
    setResending(true);
    try {
      await API.post('/resend-2fa', { email });
      toast.success('A new code has been sent to your email');
      setResendTimer(60);
      // countdown
      const iv = setInterval(() => {
        setResendTimer((t) => {
          if (t <= 1) {
            clearInterval(iv);
            return 0;
          }
          return t - 1;
        });
      }, 1000);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to resend code');
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="main-bg">

        <div className="brand-section">
          <h1>Cortex</h1>
          <p>Secure your account with Two‑Factor Authentication</p>
        </div>

      <div className="auth-container">
        <h2>2FA Verification</h2>
        <p style={{ marginBottom: '18px' }}>Enter the 6-digit code</p>
        <form onSubmit={handleVerify}>
          <input
            type="text"
            placeholder="Enter 6-digit code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            maxLength={6}
            required
          />
          <button type="submit" disabled={loading} style={{ marginTop: '12px' }}>{loading ? <span className="spinner"></span> : 'Verify'}</button>
        </form>

        <div style={{ marginTop: '25px', textAlign: 'center' }}>
          <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '14px' }}>
            Didn't receive the code?{' '}
            {resendTimer > 0 ? (
              <span style={{ color: '#00d2ff', fontWeight: 'bold' }}>{resendTimer}s</span>
            ) : (
              <span
                className="white-link"
                onClick={handleResend}
                style={{ cursor: resending ? 'not-allowed' : 'pointer' }}
              >
                {resending ? (
                  <span className="spinner" style={{ width: '12px', height: '12px', borderWidth: '2px' }}></span>
                ) : "Resend Now"}
              </span>
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Verify2FA;
